import React from "react";
import { TestimonialsSlider } from "../shared-ui.jsx";
import { nl } from "./nl.jsx";

// Sekcja referencji — reuse istniejącego TestimonialsSlider (shared-ui.jsx).
export function HomeTestimonials({
  eyebrow = "",
  headingBefore = "",
  headingHighlight = "",
  headingAfter = "",
  items = [],
  reveal = true,
}) {
  const rv = reveal ? " rv" : "";
  return (
    <section className="sec" style={{ background: "#0f1012" }}>
      <div className="container">
        <div className={"sec-head center" + rv}>
          <span className="section-eyebrow" style={{ textAlign: "center" }}>{eyebrow}</span>
          <h2 className="h2">{nl(headingBefore)}<span className="hl hl-paint">{headingHighlight}</span>{nl(headingAfter)}</h2>
        </div>
        <TestimonialsSlider items={items} />
      </div>
    </section>
  );
}
